export const DEFAULT_COMPANY_CONFIG = {
    companyName: "HỆ THỐNG SẢN XUẤT BAO BÌ APV",
    companyNameEn: "APV PACKAGING MANAGEMENT SYSTEM",
    address1: "Khu Công Nghiệp, TP. Hồ Chí Minh",
    address2: "",
    taxCode: "0000000000",
    email: "info@apv.vn",
    phone: "028 0000 0000",
    fax: "",
    bankAccount: "—",
    bankName: "Ngân hàng",
    bankBranch: "Chi nhánh",
    beneficiary: "HỆ THỐNG SẢN XUẤT BAO BÌ APV",
    // Ảnh có sẵn trong /public; logo thật lấy từ Cấu hình công ty (company_logo) khi đã tải
    logoUrl: "/artpresto-logo.png",
};

export function getCompanyConfig(config?: any) {
    const cleanConfig: any = Object.fromEntries(
        Object.entries(config || {}).filter(([_, v]) => v != null && v !== '')
    );
    
    // Map DB snake_case keys to camelCase keys for the default shape
    const mappedConfig = {
        companyName: cleanConfig.company_name || cleanConfig.companyName,
        companyNameEn: cleanConfig.company_name_en || cleanConfig.companyNameEn,
        address1: cleanConfig.company_address_1 || cleanConfig.address1,
        address2: cleanConfig.company_address_2 || cleanConfig.address2,
        taxCode: cleanConfig.company_tax_code || cleanConfig.taxCode,
        email: cleanConfig.company_email || cleanConfig.email,
        phone: cleanConfig.company_phone || cleanConfig.phone,
        fax: cleanConfig.company_fax || cleanConfig.fax,
        website: cleanConfig.company_website || cleanConfig.website,
        bankAccount: cleanConfig.company_bank_account || cleanConfig.bank_account || cleanConfig.bankAccount,
        bankName: cleanConfig.company_bank_name || cleanConfig.bank_name || cleanConfig.bankName,
        bankBranch: cleanConfig.company_bank_branch || cleanConfig.bank_branch || cleanConfig.bankBranch,
        beneficiary: cleanConfig.company_bank_beneficiary || cleanConfig.bank_beneficiary || cleanConfig.beneficiary || cleanConfig.company_name || cleanConfig.companyName,
        logoUrl: cleanConfig.company_logo || cleanConfig.logoUrl,
        defaultPaymentTerms: cleanConfig.company_payment_terms || cleanConfig.defaultPaymentTerms || cleanConfig.paymentTerms,
        defaultDeliveryTerms: cleanConfig.company_delivery_terms || cleanConfig.defaultDeliveryTerms || cleanConfig.deliveryTerms,
    };

    // Clean up undefined values from mappedConfig
    const finalConfig = Object.fromEntries(
        Object.entries(mappedConfig).filter(([_, v]) => v != null && v !== '')
    );

    return { 
        ...DEFAULT_COMPANY_CONFIG, 
        defaultPaymentTerms: "Theo thỏa thuận 2 bên",
        defaultDeliveryTerms: "Theo thỏa thuận và tiến độ của đơn hàng",
        ...finalConfig 
    };
}
